import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";
import { HIGH_RISK_COUNTRY_CODES } from "../constants";

countries.registerLocale(enLocale);

export function isHighRiskCountry(addressCountryCode) {
  if (addressCountryCode == null) return false;
  return HIGH_RISK_COUNTRY_CODES.has(addressCountryCode);
}

// Returns the same canonical country name that `CountryPicker` displays for an
// ISO Alpha-3 code (e.g. "RUS" → "Russian Federation"), or null if the code is
// missing or unrecognised. Must stay in sync with the resolver in
// `CountryPicker` so the picker label and the sorry-page text match.
export function getCountryName(addressCountryCode) {
  if (addressCountryCode == null) return null;
  return countries.getName(addressCountryCode, "en") ?? null;
}
